export { default } from "./CaseStudyTwo";
